import { createSlice } from "@reduxjs/toolkit";
import axios from "utils/axios";
import { dispatch } from "../index";
import { displayToast } from "./snackbar";
import { SnackbarType } from "utils/constants/SnackbarType";

export const initialState = {
  containerTemplates: {
    count: 0,
    rows: [],
  },
  tableView: "grid", // "grid" for table, "list" for cards
};

const slice = createSlice({
  name: "container-catalog",
  initialState,
  reducers: {
    resetContainerTemplates(state) {
      state.containerTemplates = initialState.containerTemplates;
    },
    getContainerTemplatesSuccess(state, action) {
      state.containerTemplates = action.payload;
    },
    setTableView(state, action) {
      state.tableView = action.payload;
    }
  },
});

export default slice.reducer;

export const containerCatalogActions = slice.actions;

export function getContainerTemplates({
  pageNumber,
  pageSize,
  sortField,
  sortDirection,
  searchFilter,
}) {
  return async () => {
    try {
      let params = {
        page: pageNumber,
        pageSize: pageSize,
      };
      if (sortField) {
        params.sort = sortField;
      }
      if (sortDirection) {
        params.sortDirection = sortDirection.toUpperCase(); //Available values : ASC, DESC
      }

      params = { ...params, ...searchFilter };

      const response = await axios.get(
        `${process.env.REACT_APP_TOOLING_API}/tooling/container`,
        { params },
        {}
      );
      dispatch(slice.actions.getContainerTemplatesSuccess(response.data));
    } catch (error) {
      dispatch(
        displayToast("Failed to retrieve the data for Container Catalog.", SnackbarType.Negative)
      );
      dispatch(slice.actions.resetContainerTemplates());
    }
  };
}

export async function getContainerTemplateId(tempId) {
  return axios.get(
    `${process.env.REACT_APP_TOOLING_API}/tooling/container/${tempId}`,
  );
}

export async function deleteContainerTemplateId(tempId) {
  return axios.delete(
    `${process.env.REACT_APP_TOOLING_API}/tooling/container/${tempId}`,
  );
}

export async function postContainerTemplate(formsData, tempId) {
  const params = {...formsData};

  if (tempId) {
  return axios.put(
    `${process.env.REACT_APP_TOOLING_API}/tooling/container/${tempId}`,
    {...params}
  );
  } else {
  return axios.post(
    `${process.env.REACT_APP_TOOLING_API}/tooling/container`,
    {...params}
  );
  }
}